





































import { Component, Vue } from 'nuxt-property-decorator';

import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoProgressChartV2 from '@/components/common/BravadoProgressChartV2/BravadoProgressChartV2.vue';

import { uid } from '@/components/utils/core/uid';
import { events, CountDown, CancelableNoticeError } from '@/components/common/CancelableNotice/utils';

import { NOTICE_EVENT } from '@/components/common/CancelableNotice/constants';

import type { ICancelableNotice, INoticePayload } from '@/components/common/CancelableNotice/types';

@Component<CancelableNotice>({
  name: 'CancelableNotice',
  components: { BravadoButtonV3, BravadoProgressChartV2 },
  beforeMount() {
    events.$on(NOTICE_EVENT, this.showNotice);
  },
  beforeDestroy() {
    events.$off(NOTICE_EVENT, this.showNotice);
  },
})
export default class CancelableNotice extends Vue {
  protected notices: ICancelableNotice[] = [];

  showNotice({ message, count = 3, cancelActionTitle, resolve, reject }: INoticePayload): void {
    if (!message) {
      reject(new CancelableNoticeError('Empty message provided'));
      return;
    }

    const id = uid();
    const countDown = new CountDown(count, id, this.updateCounter, this.updateProgress);

    this.notices.push({ id, message, cancelActionTitle, counter: countDown, count, progress: 0, resolve, reject });

    countDown.start();
  }

  updateCounter(nextCount: number, noticeId: string): void {
    const noticeIndex = this.notices.findIndex(notice => notice.id === noticeId);

    if (noticeIndex === -1) return;

    this.notices[noticeIndex].count = nextCount;
  }

  updateProgress(nextProgress: number, noticeId: string): void {
    const noticeIndex = this.notices.findIndex(notice => notice.id === noticeId);

    if (noticeIndex === -1) return;

    const notice = this.notices[noticeIndex];

    notice.progress = nextProgress;

    if (nextProgress === 100) {
      notice.resolve();
      this.notices.splice(noticeIndex, 1);
    }
  }

  handleCancel(canceledNotice: ICancelableNotice): void {
    const noticeIndex = this.notices.findIndex(notice => notice.id === canceledNotice.id);

    canceledNotice.counter.stop();
    canceledNotice.reject(new CancelableNoticeError('Action has been cancelled'));

    this.notices.splice(noticeIndex, 1);
  }
}
